(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('OrderPricingDialogController', OrderPricingDialogController);

    OrderPricingDialogController.$inject = ['$scope', '$mdDialog', 'order', 'quote', 'AppraisalOrder'];

    // Coupon and refund amounts come from their own records, so their Price is read-only here.
    var READ_ONLY_PRODUCT_TYPES = ['COUPON', 'PAYMENT_REFUND'];

    function OrderPricingDialogController ($scope, $mdDialog, order, quote, AppraisalOrder) {
        var vm = this;
        init(quote);

        vm.save = save;
        vm.clear = close;
        vm.isReadOnly = isReadOnly;
        vm.subTotal = subTotal;
        vm.taxTotal = taxTotal;
        vm.grandTotal = grandTotal;
        vm.appraiserSubTotal = appraiserSubTotal;
        vm.isBelowAppraiserFee = isBelowAppraiserFee;

        function init(quote) {
            vm.quote = quote;
            vm.quote.lineItems.map(initLineItem);
            vm.order = order;
        }

        /**
         * Send the new Price of every line. On success, close the dialog with the updated quote.
         * @return {promise} Promise that is resolved with the result of the service request
         */
        function save() {
            vm.isSaving = true;
            var request = {
                lines: vm.quote.lineItems.map(function(lineItem) {
                    return { lineItemId: lineItem.id, price: lineItem.price };
                }),
                comments: vm.comments
            };
            return AppraisalOrder.setOrderPricing({id: vm.order.id}, request).$promise
                .then(function(result) {
                    $scope.$emit('valueconnectApp:quoteUpdate', result);
                    $mdDialog.hide(result);
                    return result;
                }).finally(function() {
                    vm.isSaving = false;
                });
        }

        function initLineItem(lineItem) {
            lineItem.$tax = function() {
                if(!angular.isNumber(lineItem.price)) return null;
                if(!lineItem.regionalProduct) return null;
                return lineItem.price * (lineItem.regionalProduct.taxRate - 1);
            };

            lineItem.$appraiserTax = function() {
                if(!angular.isNumber(lineItem.appraiserPrice)) return null;
                if(!lineItem.regionalProduct) return null;
                return lineItem.appraiserPrice * (lineItem.regionalProduct.taxRate - 1);
            };

            lineItem.$total = function() {
                if(!angular.isNumber(lineItem.price)) return null;
                if(!lineItem.regionalProduct) return null;
                return lineItem.price + lineItem.$tax();
            };

            return lineItem;
        }

        function isReadOnly(lineItem) {
            return !lineItem.regionalProduct || READ_ONLY_PRODUCT_TYPES.indexOf(lineItem.regionalProduct.productType) !== -1;
        }

        function close() {
            $mdDialog.cancel();
        }

        function subTotal() {
            return vm.quote.lineItems
                .map(function(item) { return item.price; })
                .reduce(sum, 0);
        }

        function taxTotal() {
            return vm.quote.lineItems
                .map(function(item) { return item.$tax(); })
                .reduce(sum, 0);
        }

        function grandTotal() {
            return vm.quote.lineItems
                .map(function(item) { return item.$total(); })
                .reduce(sum, 0);
        }

        function appraiserSubTotal() {
            return vm.quote.lineItems
                .map(function(item) { return item.appraiserPrice; })
                .reduce(sum, 0);
        }

        function isBelowAppraiserFee() {
            return subTotal() < appraiserSubTotal();
        }

        function sum(a,b) {
            var aIsNum = angular.isNumber(a), bIsNum = angular.isNumber(b);
            if(!aIsNum && !bIsNum) return null;
            else if(!aIsNum) return b;
            else if(!bIsNum) return a;
            else return a + b;
        }
    }
})();
